import {
    ASSESSMENT_URL
} from '../../utils/url-builder'
import BaseService from '../services/base.service'

class QuestionsService extends BaseService {
    constructor() {
        super(ASSESSMENT_URL)
        this.route = "question/";
    }
    create = (assessmentId, description, points, type) => {
        return new Promise(async (resolve, reject) => {

            try {
                await this.makePostRequest(this.route + 'create', {
                    assessmentId: assessmentId,
                    description: description,
                    points: points,
                    type: type
                }, false);
                return resolve();
            } catch (error) {
                reject(error)
            }
        })
    }

    duplicateQuestion = (questionId) => new Promise(async (resolve, reject) => {
        try {
            await this.makePostRequest(this.route + "duplicate", { questionId }, false);
            return resolve()
        } catch (error) {
            reject(error)
        }
    })

    fetch = (assessmentId, showNormalLoader = true) => {
        return new Promise(async (resolve, reject) => {
            try {
                let res = await this.makeGetRequest(this.route + 'fetch', { assessmentId }, showNormalLoader);
                return resolve(res);
            } catch (error) {
                reject(error)
            }
        })
    }

}

const questionService = new QuestionsService()
export default questionService







  
